import VectorSource from 'ol/source/Vector';

import { ClassicSketchApi } from 'cadenza/api-client/classic-sketch-api';
import { logger } from 'cadenza/utils/logging';
import { getMainStyle } from 'cadenza/map/classic-sketch-layer/sketch-style';

import { SketchFormat } from './sketch-format';

export const FEATURE_MIN_Z_INDEX_VALUE = 1;

export class SketchLayerSource extends VectorSource {

  constructor ({ layerId }) {
    const sketchApi = new ClassicSketchApi(layerId);

    super({
      format: new SketchFormat(),

      loader () {
        this.set('loadend', false);
        sketchApi.load()
          .then(res => this.getFormat().readFeatures(res))
          .then(features => this.addFeatures(features))
          .catch((error) => {
            logger.error('Failed to get sketch layer features', error);
          }).finally(() => {
            this.set('loadend', true);
          });
      },

      useSpatialIndex: false // ensure feature order
    });

    // Ensure feature render order. We should set the z indices, because only in this way custom geometries rendered with a custom renderer can be rendered in the right order.
    // By default OL renders all features with custom renderers on top of everything else.
    this.on('change', () => {
      let zIndex = FEATURE_MIN_Z_INDEX_VALUE;
      this.getFeatures().forEach(feature => {
        getMainStyle(feature).setZIndex(zIndex++);
      });
    });
  }

}
